import { PostMethod } from '../../serviceHelper';

const getMethods = (service: 'main', controller: 'Announcement') => ({
	UpdateAnnouncement: new PostMethod<any, any>({
		service,
		controller,
		method: 'UpdateAnnouncement'
	}),
	MarkAnnouncementAsRead: new PostMethod<boolean, any>({
		service,
		controller,
		method: 'MarkAnnouncementAsRead'
	}),
	AddAnnouncement: new PostMethod<any, any>({
		service,
		controller,
		method: 'AddAnnouncement'
	}),
	DeleteAnnouncement: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeleteAnnouncement'
	}),
	GetAllAnnouncements: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetAllAnnouncements'
	}),
	GetAllAnnouncementsStartup: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetAllAnnouncementsStartup'
	}),
	GetAnnouncement: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetAnnouncement'
	}),
	GetActiveAnnouncementsByUser: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetActiveAnnouncementsByUser'
	}),
	GetAllAnnouncementsByUser: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetAllAnnouncementsByUser'
	})
});

export { getMethods };
